export const isDeprecatedPlatform = (
  platformIdentifier: string | undefined,
): boolean => {
  if (!platformIdentifier) {
    return false;
  }

  const isDeprecatedById =
    platformIdentifier === 'xandr_integrated' ||
    platformIdentifier === 'xandrIntegrated';

  return isDeprecatedById;
};
